var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-play",on:{"click":function($event){return _vm.$router.push('/curriculums/broadcast')}}},[_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/h-icons/video-play.png")}}),(_vm.live_open == 1)?_c('div',{staticClass:"status-tip"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }